import React from "react";

const Icon = props => (
  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" focusable="false" {...props}>
    <path fill="currentColor" d="M4.55,4.5l8.11,11.58L4.5,25.5H6.34l7.14-8.25,5.77,8.25H25.5L16.94,13.27,24.53,4.5H22.69l-6.57,7.59L10.8,4.5ZM7.25,6h2.87L22.8,24.05H19.93Z" />
  </svg>
);

export default Icon;
